import { render, staticRenderFns } from "./CreateNewTeam.vue?vue&type=template&id=68aabc06&scoped=true"
import script from "./CreateNewTeam.vue?vue&type=script&lang=js"
export * from "./CreateNewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aabc06",
  null
  
)

export default component.exports